import { gql } from "@apollo/client";

export const CREATE_SADDLE = gql`
mutation createSaddleFitSaddle($input: CreateSaddleFitSaddleInput!) {
    createSaddleFitSaddle(input: $input) {
      pk
      sk
      productTitle
      type
      brandName
      createdAt
      discipline
      newOrUsed
      price
      photo
      quantity
      score
      status
      updatedAt
      userId
      manufacturerMeasurements {
        barAngle
        gulletHeight
        gulletWidth
      }
      measurements {
        barAngle
        gulletHeight
        gulletWidth
      }
      description
      gallery
      variantId
    }
  }
`;